interface GradientColorStop {
    offset: number
    color: string
}

interface RectangleOptions {
    width: number,
    height: number,
    lineWidth?: number
    radius?: number
    strokeStyle?: string | Array<GradientColorStop>
    fillStyle?: string | Array<GradientColorStop>
}

interface DrawToCanvas {
    (options: RectangleOptions) : HTMLCanvasElement
}

class RectangleClass {
    private static instance: RectangleClass

    public drawToCanvas: DrawToCanvas

    private constructor() {}

    public static get Instance() : RectangleClass {
        return this.instance || (this.instance = new this())
    }

    static drawToCanvas(options: RectangleOptions) : HTMLCanvasElement {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let shouldStroke: boolean = true

        canvas.width = options.width
        canvas.height = options.height
        ctx.clearRect( 0, 0, options.width, options.height)

        if (typeof options.strokeStyle !== 'undefined') {
            if (typeof options.strokeStyle === 'string') {
                ctx.strokeStyle = options.strokeStyle
            } else {
                let gradient = ctx.createLinearGradient(0, 0, 0, options.height)
                for (let i = 0; i < options.strokeStyle.length; i++) {
                    gradient.addColorStop(options.strokeStyle[i].offset, options.strokeStyle[i].color)
                }
                ctx.strokeStyle = gradient
            }
        } else {
            shouldStroke = false
        }

        if (typeof options.fillStyle !== 'undefined') {
            if (typeof options.fillStyle === 'string') {
                ctx.fillStyle = options.fillStyle
            } else {
                let gradient = ctx.createLinearGradient(0, 0, 0, options.height)
                for (let i = 0; i < options.fillStyle.length; i++) {
                    gradient.addColorStop(options.fillStyle[i].offset, options.fillStyle[i].color)
                }
                ctx.fillStyle = gradient
            }
        }

        RectangleClass.drawRoundRect(ctx, options.width, options.height, options.lineWidth || 0, options.radius || 0, shouldStroke)

        return canvas
    }

    static drawRoundRect(ctx: CanvasRenderingContext2D, width: number, height: number, lineWidth: number, radius: number, stroke: boolean) {
        const x = 0
        const y = 0
        ctx.lineWidth = lineWidth * 2

        ctx.beginPath()
        ctx.moveTo(x + radius + lineWidth, y + lineWidth)
        ctx.lineTo(x + width - radius - lineWidth, y + lineWidth) // top horizontal
        ctx.quadraticCurveTo(x + width - lineWidth, y + lineWidth, x + width - lineWidth, y + radius + lineWidth)
        ctx.lineTo(x + width - lineWidth, y + height - radius - lineWidth) // right vertical
        ctx.quadraticCurveTo(
            x + width - lineWidth,
            y + height - lineWidth,
            x + width - radius - lineWidth,
            y + height - lineWidth
        )
        ctx.lineTo(x + radius + lineWidth, y + height - lineWidth) // bottom horizontal
        ctx.quadraticCurveTo(x + lineWidth, y + height - lineWidth, x + lineWidth, y + height - radius - lineWidth)
        ctx.lineTo(x + lineWidth, y + radius + lineWidth) // left vertical
        ctx.quadraticCurveTo(x + lineWidth, y + lineWidth, x + radius + lineWidth, y + lineWidth)
        ctx.closePath()

        if (stroke) {
            ctx.stroke()
        }
        ctx.fill()
    }
}

const Rectangle = RectangleClass.Instance
Rectangle.drawToCanvas = RectangleClass.drawToCanvas

export { Rectangle, RectangleOptions, GradientColorStop }
